import React, { useEffect, useState } from "react";

// import { deleteArtisanPublicInquiryAction, getArtisanPublicInquiryAction, getArtisnPublicInquiriesAction,addArtisanPublicInquiryAction, editArtisanPublicInquiryAction } from '../../../../modules/inquiries/artisans/public/Actions'

import { getCustomerArtisanFollowngList , removeFavArtisanPoductAction} from '../../../../modules/customerFollowingArtisanList/Actions';

import {
  customerArtisanFollowingListAsNameAndId,
  customerArtisanFollowingListLoadingSelector,
  customerArtisanFollowingListCountSelector,
} from '../../../../modules/customerFollowingArtisanList/Selectors';

import { authUserIdSelector, customerDataSelector} from '../../../../modules/auth/Selectors';

// import {
//   PublicArtisanListSelector,
//   artisanPublicInquiriesSelector,
//   artisanPublicInquiriesIsLoadingSelector,
// } from '../../../../modules/inquiries/artisans/public/Selectors';

import { connect } from "react-redux";

import List from "../../../../components/Lists/List";
import ListItem from "../../../../components/Lists/ListItem";
import InfiniteScroll from "react-infinite-scroll-component";
import getLangData from "../../../../utils/getLangData";

const FollowingList = (props) => {
  const {
    publicInquiries,
    publicInquiriesIsLoading,
    getPublicInquiries,
    followinglistCout,
    deletePublicArtisanInquiry,
    followingList,
    getFollowingList,
    removeFollowing,
    followingListLoading,
    customerData,
    userId
  } = props;

  const [size, setSize] = useState(10);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);

    // for testing only

    // const userId = '5fa3fb8430e726002c46c662';
    const customerId = customerData._id


  useEffect(() => {
    getFollowingList(customerId);
  }, []);

  const fetchMore = () => {
    // set hasMore to false if the current items are >= the all items in database !
    if (followingList.length >= followinglistCout) {
      setHasMore(false);
      return false;
    }

    // otherwise get the data from the database
    getPublicInquiries({ size, offset: followingList.length });
  };

  const dataLength =
    followingList.length <= followinglistCout
      ? followingList.length
      : followinglistCout;

  return (
    <List
      isLoading={followingListLoading}
      header={{ items: [getLangData().fields.message], actions: ["Remove"] }}
      items={followingList}
    >
      {/* <InfiniteScroll
        dataLength={dataLength}
        hasMore={hasMore}
        next={fetchMore}
      > */}
        {followingList.map(({ businessName, message , _id,  }) => {
          return (
            <ListItem
              //  type='multi'
               name={businessName}
              // data={[message]} 
              key={_id}
              // viewLink={`/customer-public-inquiry-artisan/${_id}`}
              onDelete={() => {
                const body = {
                  artisanId: _id,
                  userID: userId
                }
                removeFollowing(body) 
              }}
          >{console.log(followingList)}</ListItem>
          );
        })}
      {/* </InfiniteScroll> */}
    </List>
  );
};

const mapStateToProps = (state) => ({
  followingList: customerArtisanFollowingListAsNameAndId(state),
  followingListLoading: customerArtisanFollowingListLoadingSelector(
    state
  ),
  followinglistCout: customerArtisanFollowingListCountSelector(state),
  customerData: customerDataSelector(state),
  userId: authUserIdSelector(state)
});

export default connect(mapStateToProps, {
  getFollowingList: getCustomerArtisanFollowngList,
  removeFollowing: removeFavArtisanPoductAction,
})(FollowingList);


//  getCustomerArtisanFollowngList , removeFavArtisanPoductAction} 
// import {
//   customerArtisanFollowingListAsNameAndId,
//   customerArtisanFollowingListLoadingSelector,
//   customerArtisanFollowingListCountSelector,